<template>
  <!-- Business Section -->
  <section class="py-16 bg-gradient-to-r from-gray-50 to-gray-100" id="send-question">
    <div class="container mx-auto px-4">
      <div class="max-w-3xl mx-auto">
        <div class="text-center mb-8">
          <h2 class="text-3xl font-bold mb-4 text-[#B89666]">Pošljite povpraševanje strokovnjaku</h2>
          <p class="text-gray-600 mb-6">
            Izberite tip povpraševanja in izpolnite obrazec. Ponudnik vas bo kontaktiral v najkrajšem možnem času.
          </p>
        </div>
        
        <div class="bg-white border rounded-lg shadow-lg">
          <v-card class="border-0 shadow-none">
            <v-card-text class="p-0">
              <v-tabs
                v-model="tab"
                @update:modelValue="clearForm()"
                class="border-b"
              >
                <v-tab value="contact_request" :prepend-icon="'mdi-human-capacity-increase'">Zahteva za kontakt</v-tab>
                <v-tab value="visit_request" :prepend-icon="'mdi-human-greeting-proximity'">Zahteva za sestanek</v-tab>
                <v-tab value="question" :prepend-icon="'mdi-chat-question'">Vprašanje</v-tab>
              </v-tabs>

              <v-tabs-window v-model="tab">
                <!-- Contact Request Tab -->
                <v-tabs-window-item value="contact_request">
                  <div class="p-6">
                    <v-alert
                      v-if="showSuccessMessage"
                      type="success"
                      variant="tonal"
                      class="mb-4"
                    >
                      <p class="font-semibold">Hvala za vaše povpraševanje!</p>
                      <p class="text-sm">Vaše povpraševanje je bilo uspešno poslano. Ponudnik vas bo kontaktiral v najkrajšem možnem času.</p>
                    </v-alert>

                    <v-alert
                      border="start"
                      border-color="deep-purple accent-4"
                      elevation="2"
                      class="mb-4"
                      text="Za lažjo in hitrejšo obravnavo vas prosimo, da izpolnite spodnji obrazec. Po prejemu vaše želje vas bo ponudnik kontaktiral v najkrajšem možnem času."
                      title="Zahteva za kontakt"
                    ></v-alert>

                    <v-select
                      v-model="form.business_type"
                      :items="companyTypeOptions"
                      label="Tip strokovnjaka"
                      variant="outlined"
                      density="comfortable"
                      item-title="label"
                      item-value="value"
                      :error-messages="form.errors.business_type"
                      class="mb-4"
                    ></v-select>

                    <v-text-field
                      v-model="form.name"
                      label="Vaše ime"
                      variant="outlined"
                      density="comfortable"
                      :error-messages="form.errors.name"
                      class="mb-4"
                    ></v-text-field>

                    <v-text-field
                      v-model="form.last_name"
                      label="Vaš priimek"
                      variant="outlined"
                      density="comfortable"
                      :error-messages="form.errors.last_name"
                      class="mb-4"
                    ></v-text-field>

                    <v-text-field
                      v-model="form.email"
                      label="Vaš e-poštni naslov"
                      variant="outlined"
                      density="comfortable"
                      type="email"
                      :error-messages="form.errors.email"
                      class="mb-4"
                    ></v-text-field>

                    <v-text-field
                      v-model="form.phone_number"
                      label="Vaša telefonska številka"
                      variant="outlined"
                      density="comfortable"
                      :error-messages="form.errors.phone_number"
                      class="mb-4"
                    ></v-text-field>

                    <v-textarea
                      v-model="form.message"
                      label="Vaše sporočilo"
                      variant="outlined"
                      rows="4"
                      :error-messages="form.errors.message"
                      class="mb-4"
                    ></v-textarea>
                  </div>
                </v-tabs-window-item>

                <!-- Visit Request Tab -->
                <v-tabs-window-item value="visit_request">
                  <div class="p-6">
                    <v-alert
                      v-if="showSuccessMessage"
                      type="success"
                      variant="tonal"
                      class="mb-4"
                    >
                      <p class="font-semibold">Hvala za vaše povpraševanje!</p>
                      <p class="text-sm">Vaše povpraševanje je bilo uspešno poslano. Ponudnik vas bo kontaktiral v najkrajšem možnem času.</p>
                    </v-alert>

                    <v-alert
                      border="start"
                      border-color="deep-purple accent-4"
                      elevation="2"
                      class="mb-4"
                      text="Za lažjo in hitrejšo obravnavo vas prosimo, da izpolnite spodnji obrazec. Po prejemu vaše želje vas bo ponudnik kontaktiral v najkrajšem možnem času."
                      title="Zahteva za sestanek"
                    ></v-alert>

                    <v-select
                      v-model="form.business_type"
                      :items="companyTypeOptions"
                      label="Tip strokovnjaka"
                      variant="outlined"
                      density="comfortable"
                      item-title="label"
                      item-value="value"
                      :error-messages="form.errors.business_type"
                      class="mb-4"
                    ></v-select>

                    <v-text-field
                      v-model="form.name"
                      label="Vaše ime"
                      variant="outlined"
                      density="comfortable"
                      :error-messages="form.errors.name"
                      class="mb-4"
                    ></v-text-field>

                    <v-text-field
                      v-model="form.last_name"
                      label="Vaš priimek"
                      variant="outlined"
                      density="comfortable"
                      :error-messages="form.errors.last_name"
                      class="mb-4"
                    ></v-text-field>

                    <v-text-field
                      v-model="form.email"
                      label="Vaš e-poštni naslov"
                      variant="outlined"
                      density="comfortable"
                      type="email"
                      :error-messages="form.errors.email"
                      class="mb-4"
                    ></v-text-field>

                    <v-text-field
                      v-model="form.phone_number"
                      label="Vaša telefonska številka"
                      variant="outlined"
                      density="comfortable"
                      :error-messages="form.errors.phone_number"
                      class="mb-4"
                    ></v-text-field>

                    <v-textarea
                      v-model="form.message"
                      label="Vaše sporočilo"
                      variant="outlined"
                      rows="4"
                      :error-messages="form.errors.message"
                      class="mb-4"
                    ></v-textarea>

                    <Datepicker
                      v-model="form.prefered_date" 
                      header="Željeni čas sestanka"
                      placeholder="Izberi datum in čas začetka sestanka"
                      :error="form.errors.prefered_date"
                      :error-messages="form.errors.prefered_date"
                      class="text-black mb-4"
                      label="Željeni čas sestanka"
                    />
                  </div>
                </v-tabs-window-item>

                <!-- Question Tab -->
                <v-tabs-window-item value="question">
                  <div class="p-6">
                    <v-alert
                      v-if="showSuccessMessage"
                      type="success"
                      variant="tonal"
                      class="mb-4"
                    >
                      <p class="font-semibold">Hvala za vaše vprašanje!</p>
                      <p class="text-sm">Vaše vprašanje je bilo uspešno poslano. Ponudnik vas bo kontaktiral v najkrajšem možnem času.</p>
                    </v-alert>

                    <v-alert
                      border="start"
                      border-color="deep-purple accent-4"
                      elevation="2"
                      class="mb-4"
                      text="V spodnjem obrazcu lahko zastavite vprašanje ponudniku storitve. Prosimo vas, da vprašanje oblikujete natančno, jasno in jedrnato, da vam bo ponudnik lahko hitro in ustrezno odgovoril."
                      title="Vprašanje"
                    ></v-alert>

                    <v-select
                      v-model="form.business_type"
                      :items="companyTypeOptions"
                      label="Tip strokovnjaka"
                      variant="outlined"
                      density="comfortable"
                      item-title="label"
                      item-value="value"
                      :error-messages="form.errors.business_type"
                      class="mb-4"
                    ></v-select>

                    <v-text-field
                      v-model="form.name"
                      label="Vaše ime"
                      variant="outlined"
                      density="comfortable"
                      :error-messages="form.errors.name"
                      class="mb-4"
                    ></v-text-field>

                    <v-text-field
                      v-model="form.last_name"
                      label="Vaš priimek"
                      variant="outlined"
                      density="comfortable"
                      :error-messages="form.errors.last_name"
                      class="mb-4"
                    ></v-text-field>

                    <v-text-field
                      v-model="form.email"
                      label="Vaš e-poštni naslov"
                      variant="outlined"
                      density="comfortable"
                      type="email"
                      :error-messages="form.errors.email"
                      class="mb-4"
                    ></v-text-field>

                    <v-text-field
                      v-model="form.phone_number"
                      label="Vaša telefonska številka"
                      variant="outlined"
                      density="comfortable"
                      :error-messages="form.errors.phone_number"
                      class="mb-4"
                    ></v-text-field>

                    <v-textarea
                      v-model="form.message"
                      label="Vaše vprašanje"
                      variant="outlined"
                      rows="4"
                      :error-messages="form.errors.message"
                      class="mb-4"
                    ></v-textarea>
                  </div>
                </v-tabs-window-item>
              </v-tabs-window>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions class="flex flex-col gap-2 p-6">
              <div class="flex flex-row gap-2 w-full justify-end">
                <v-btn
                  color="grey"
                  variant="flat"
                  @click="clearForm"
                >
                  Počisti
                </v-btn>
                <v-btn
                  color="primary"
                  variant="flat"
                  @click="submitForm"
                  :disabled="form.processing"
                  :loading="form.processing"
                >
                  Pošlji
                </v-btn>
              </div>

              <v-alert
                border="start"
                border-color="deep-purple accent-4"
                elevation="2"
                class="mt-4 w-full"
                title="Pomembno:"
              >
                <ul class="text-sm space-y-1">
                  <li>• Vaši podatki bodo uporabljeni izključno za namen komunikacije s ponudnikom.</li>
                  <li>• Vsi oddana podatki bodo obravnavani zaupno in uporabljeni izključno za namen odgovora.</li>
                  <li>• Pozorno preverite vaše kontaktne podatke, saj vas bodo ponudniki tako lažje kontaktirali.</li>
                </ul>
              </v-alert>
            </v-card-actions>
          </v-card>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, watch, computed } from 'vue'
import { useForm } from '@inertiajs/vue3'
import { useMainStore } from '@/stores/main'
import Datepicker from '@/components/Form/Datepicker.vue'

const mainStore = useMainStore()
const showSuccessMessage = ref(false)
const tab = ref('question')

const companyTypeOptions = [
  { label: 'Odvetniki', value: 'law_office' },
  { label: 'Notarji', value: 'notary' },
  { label: 'Cenilci', value: 'appraiser' },
  { label: 'Stečajni upravitelji', value: 'liquidator' },
  { label: 'Sodni izvedenec', value: 'court_expert' },
  { label: 'Sodni tolmač', value: 'court_interpreter' },
  { label: 'Izvršitelj', value: 'enforcement_officer' },
  { label: 'Poravnalec', value: 'settlement_mediator' },
]

const form = useForm({
  type: null,
  name: null,
  last_name: null,
  email: null,
  phone_number: null,
  message: null,
  prefered_date: null,
  rel_company: null, // here is alway null because we are sending question to all companies
  business_type: null,
})

// Watch for changes in the store and update form
watch(() => mainStore.selectedQuestionCompanyType, (newValue) => {
  if (newValue) {
    form.business_type = newValue
  }
}, { immediate: true })

const submitForm = () => {
  form.type = tab.value
  form.post(route('iuromat.leads.external-store'), {
    preserveScroll: true,
    onSuccess: () => {
      showSuccessMessage.value = true
      clearForm()
      // Scroll to top of form to show success message
      setTimeout(() => {
        const element = document.getElementById('send-question')
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }, 100)
      // Hide success message after 5 seconds
      setTimeout(() => {
        showSuccessMessage.value = false
      }, 5000)
    },
  })
}

const clearForm = () => {
  form.reset()
  // Preserve business_type if it was set from store
  if (mainStore.selectedQuestionCompanyType) {
    form.business_type = mainStore.selectedQuestionCompanyType
  }
}

onMounted(() => {
  // Set business type from store if available
  if (mainStore.selectedQuestionCompanyType) {
    form.business_type = mainStore.selectedQuestionCompanyType
  }
})
</script>
